import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux'
import { getStore } from '../redux/store' 
import MenuBarLicenseSelector from '../myjsx/components/menuBarLicenseSelector'

global.license = {
	individualLicense:1,
	familyLicense:2,
	homeschoolLicense:3,
	schoolLicense:4,
	classroomLicense:8,
	teacher1License:10,
	teacher3License:11,
	studentLicense:1,
	teacherLicense:2,
	studentRoleId:11,
	teacherRoleId:10,
	translatorRoleIdEn:19,
	translatorRoleIdEs:20,

	/*
	 * Tries to reactivate the user with the supplies license key
	 */
	reActivate:function(newLicenseKey) {
		var data={};
		
		data.key=newLicenseKey;

		
		$('#licenseMessages').empty();
		$('#licenseMessages').removeClass('text-color-red text-color-green');

		// We send the invite and receive the channel back
		var url = 'index.php?component=com_otu_op&task=license.reActivate';
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
				callback : function(json) {
				if (json.messages!==null) {
					$('#licenseMessages').addClass('text-color-red');

					license._reportMessages(json);
				} 

				if (json.success) {
					$('#licenseMessages').addClass('text-color-green');
					license._reportMessages(json);
					
					// we unload the menubar so it gets properly reinitialized
					otuApp.unloadMenuBar();
					
					setTimeout(function(){
						var url = 'index.php?component=com_otu_op&task=goToStep&step=0';
						otuApp.triggerAjaxPost(url, {attr:{'data-hide-template-position':'columns-all'}});
						console.log('License - success');						
					},3000);

				}
			}
		})		
	},
	isStudent: function() {
		if (Array.isArray(otuApp.appUser.roles)) return otuApp.appUser.isStudent;
		return false;
	},
	isTeam: function() {
		if (Array.isArray(otuApp.appUser.roles)) return otuApp.appUser.isTeam;
		return false;
	},
	isTeacher: function() {
		if (Array.isArray(otuApp.appUser.roles)) return otuApp.appUser.isTeacher;
		return false;
	},
	isTranslator: function() {
		if (Array.isArray(otuApp.appUser.roles)) return ( otuApp.appUser.roles.includes(license.translatorRoleIdEs) || otuApp.appUser.roles.includes(license.translatorRoleIdEn) );
		return false;
	},
	isFreeTrial : function () {
		return Boolean(otuApp.appUser.json.freeTrial);
	},
	_reportMessages:function(json){
		console.log(json);
		$('#licenseMessages').empty();
		$.each(json.messages,function(key,value) {
			console.log(key);
			console.log(value);
	
			$.each(value,function (sKey,sValue) {
				$('#licenseMessages').append('<p>' + sValue + '</p>');
			});
		});
	},
	initMenuBarLicenseSelector : function( options={} ) {
		const appStore = getStore();
		const props = options.props;

		const element = (
			<Provider store = { appStore }>
				<MenuBarLicenseSelector { ...props } ></MenuBarLicenseSelector>
			</Provider>
		)
	
		ReactDOM.render( element, document.getElementById('menuBarLicenseSelector'), function (e) {})
	}
		
};